<template>
<div class="mall_body">

  <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
    <van-swipe-item>1</van-swipe-item>
    <van-swipe-item>2</van-swipe-item>
    <van-swipe-item>3</van-swipe-item>
    <van-swipe-item>4</van-swipe-item>
  </van-swipe>

  <div class="biaoti">
    <div class="shangping">苹果手机</div>
    <div class="jifen">所需积分：450</div>
    <div class="shengyu">剩余件数：10/99</div>
    <div class="anniu"><van-button type="primary" size="small" @click="duihuan">立即兑换</van-button></div>
  </div>

  <van-divider>商品详情</van-divider>

  <div class="xiangqing">
    <div v-for="item in 4"><img src="/6.jpeg"></div>
  </div>



</div>
</template>

<script>
    export default {
        name: "Mall",
        data(){
            return{

            }
        },
        created() {

        },
        methods:{
            duihuan(){
                this.$router.push({ path:'/exchange'  })
            }

        }
    }
</script>

<style scoped lang="stylus">
  .biaoti{
    width 100%;
    position relative;
    .shangping{
      color #333333;
      font-size 16px;
      font-weight 500;
      margin-left 10px;
      margin-top 10px;
    }
    .shengyu{
      margin-left 10px;
      margin-top 10px;
    }
    .jifen{
      margin-left 10px;
      margin-top 10px;
    }
    .anniu{
      position absolute;
      right 20px;
      top 20px;
    }
  }

  .tupian{
    width 100%;
    img{
      width 100%;
      height 150px;
    }
  }
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }

  .xiangqing{
    width 95%;
    margin auto;
    div{
      width 95%;
      margin auto
    }
    img{
      width 100%;
      height 150px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/Shopping/Mall.vue